import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'USER_WITHDRAWAL_REQUESTS';

export const GET_OPEN = getLifecycle(REDUCER_NAME, 'GET_OPEN');
export const CANCEL = getLifecycle(REDUCER_NAME, 'CANCEL');